import React from 'react'

const Underline = () => {
  return (
    <div >

    <div className='w-20 h-1 bg-black underline-box'>

    </div>
    </div>
  )
}

export default Underline